import React from 'react';
import { Plus } from 'lucide-react';
import ShotCardText from './ShotCardText';
import { useTheme } from '../../../context/ThemeContext';

const VirtualTextList = ({
  rows,
  listViewProps,
  onInsertAtTop,
  isGlobalLocked,
}) => {
  const { getTheme } = useTheme();
  const theme = getTheme();

  const headerBorder = '1px solid var(--color-border-primary)';
  const getRowKey = (scene, index) => scene?.__clientKey || scene?.id || index;

  return (
    <div className="absolute inset-0 overflow-y-auto custom-scrollbar">
      <div className="px-8 py-5 pb-32">
        {/* 顶部插入按钮 */}
        <div
          onClick={() => !isGlobalLocked && onInsertAtTop?.()}
          className="w-full h-7 rounded flex items-center justify-center cursor-pointer transition-all duration-200 border border-dashed mb-3"
          style={{
            borderColor: isGlobalLocked ? 'transparent' : 'var(--color-border-primary)',
            color: 'var(--color-text-muted)',
            opacity: isGlobalLocked ? 0.3 : 1,
          }}
          onMouseEnter={(e) => { if (!isGlobalLocked) { e.currentTarget.style.borderColor = theme.colors.accentPrimary; e.currentTarget.style.color = theme.colors.accentPrimary; }}}
          onMouseLeave={(e) => { if (!isGlobalLocked) { e.currentTarget.style.borderColor = 'var(--color-border-primary)'; e.currentTarget.style.color = 'var(--color-text-muted)'; }}}
        >
          <Plus size={12} />
          <span className="text-2xs font-medium ml-1">插入镜头</span>
        </div>

        {/* 表格 */}
        <table className="w-full border-collapse rounded-lg" style={{ tableLayout: 'fixed', border: '1px solid var(--color-border-primary)' }}>
          <colgroup>
            <col style={{ width: '52px' }} />
            <col style={{ width: '60px' }} />
            <col style={{ width: '40%' }} />
            <col />
            <col />
            <col style={{ width: '52px' }} />
            <col style={{ width: '40px' }} />
          </colgroup>
          <thead className="sticky top-0 z-10">
            <tr style={{ backgroundColor: 'var(--color-bg-secondary)' }}>
              <th className="px-3 py-2.5 text-2xs font-bold text-center" style={{ color: 'var(--color-text-muted)', borderBottom: headerBorder, borderRight: headerBorder, width: '52px' }}>镜号</th>
              <th className="px-2 py-2.5 text-2xs font-bold text-left" style={{ color: 'var(--color-text-muted)', borderBottom: headerBorder, borderRight: headerBorder, width: '60px' }}>景别</th>
              <th className="px-3 py-2.5 text-2xs font-bold text-left" style={{ color: theme.colors.accentPrimary, borderBottom: `2px solid ${theme.colors.accentPrimary}40`, borderRight: headerBorder, width: '40%' }}>
                ★ 生图提示词
              </th>
              <th className="px-2 py-2.5 text-2xs font-bold text-left" style={{ color: 'var(--color-text-muted)', borderBottom: headerBorder, borderRight: headerBorder }}>画面描述</th>
              <th className="px-2 py-2.5 text-2xs font-bold text-left" style={{ color: 'var(--color-text-muted)', borderBottom: headerBorder, borderRight: headerBorder }}>对白</th>
              <th className="px-2 py-2.5 text-2xs font-bold text-center" style={{ color: 'var(--color-text-muted)', borderBottom: headerBorder, borderRight: headerBorder, width: '52px' }}>时长</th>
              <th className="px-2 py-2.5 text-2xs font-bold text-center" style={{ color: 'var(--color-text-muted)', borderBottom: headerBorder, width: '40px' }}></th>
            </tr>
          </thead>
          <tbody>
            {rows && rows.map((scene, index) => (
              <ShotCardText
                key={getRowKey(scene, index)}
                scene={scene}
                index={index}
                handleChange={listViewProps.handleChange}
                handleInsertRow={listViewProps.handleInsertRow}
                handleDeleteRow={listViewProps.handleDeleteRow}
                selectedShots={listViewProps.selectedShots}
                toggleShotSelection={listViewProps.toggleShotSelection}
                isMultiSelectMode={listViewProps.isMultiSelectMode}
                isGlobalLocked={isGlobalLocked}
              />
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default VirtualTextList;
